import {
  SEP_RN_DEFAULT_DER_CONTROL,
  SEP_RN_DER_AVAILABILITY,
  SEP_RN_DER_CAPABILITY,
  SEP_RN_DER_SETTINGS,
  SEP_RN_DER_STATUS
} from 'utils/appConstants';

import { DerAvailabilitySchema } from './DerAvailability';
import { DerSettingsSchema } from './DerSettings';
import { DerStatusSchema } from './DerStatus';
import { DerCapabilitySchema } from './DerCapability';
import { DefaultDERControlSchema } from './DefaultDERControl';

export const Schemas = {
  [SEP_RN_DER_AVAILABILITY]: DerAvailabilitySchema,
  [SEP_RN_DER_SETTINGS]: DerSettingsSchema,
  [SEP_RN_DER_CAPABILITY]: DerCapabilitySchema,
  [SEP_RN_DEFAULT_DER_CONTROL]: DefaultDERControlSchema,
  [SEP_RN_DER_STATUS]: DerStatusSchema
};
